import { render } from "./TransitionFade.vue?vue&type=template&id=749c01e2"
import script from "./TransitionFade.vue?vue&type=script&lang=ts"
export * from "./TransitionFade.vue?vue&type=script&lang=ts"

import "./TransitionFade.vue?vue&type=style&index=0&id=749c01e2&lang=scss"
script.render = render

export default script